module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [(_vm.action === 'update') ? _c('mass-update', {
    attrs: {
      "tariffs": _vm.tableData,
      "maxValue": _vm.maxValue,
      "details": _vm.details,
      "additions": _vm.additions,
      "req": _vm.updateRequestBody
    },
    on: {
      "update": _vm.update
    }
  }) : _vm._e(), _vm._v(" "), _c('loader', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }]
  }), _vm._v(" "), _c('vuetable', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.loading),
      expression: "!loading"
    }],
    attrs: {
      "showEdit": true,
      "showDelete": true,
      "showSelectAll": true,
      "tableData": _vm.tableData,
      "allowSelect": true,
      "tableTitle": "Tariffs",
      "fields": _vm.fields,
      "maxItems": _vm.maxValue
    },
    on: {
      "table-delete-request": _vm.deleteEntity,
      "table-edit-request": _vm.handleEdit,
      "select-all": _vm.deleteAll,
      "pages-remaining": _vm.loadMore
    }
  }, [_c('div', {
    attrs: {
      "slot": "head-slot"
    },
    slot: "head-slot"
  }, [(_vm.action === 'unsuspend' || _vm.action === 'suspend') ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label",
    attrs: {
      "for": "effectiveTo"
    }
  }, [_vm._v("Effective To")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.effectiveTo),
      expression: "effectiveTo"
    }],
    staticClass: "mai-date",
    attrs: {
      "id": "effectiveTo",
      "type": "date"
    },
    domProps: {
      "value": (_vm.effectiveTo)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.effectiveTo = $event.target.value
      }
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.action === 'unsuspend') ? _c('div', {
    staticClass: "btn btn-primary sq",
    staticStyle: {
      "width": "99%"
    },
    on: {
      "click": _vm.selectedUnsuspend
    }
  }, [_vm._v("\n        Unsuspend " + _vm._s(_vm.selectedTariffs.length) + " item(s)\n      ")]) : _vm._e(), _vm._v(" "), (_vm.action === 'suspend') ? _c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.quickReason),
      expression: "quickReason"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "Reason"
    },
    domProps: {
      "value": (_vm.quickReason)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.quickReason = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "btn btn-primary sq",
    staticStyle: {
      "width": "99%"
    },
    on: {
      "click": _vm.selectedSuspend
    }
  }, [_vm._v("\n          Suspend " + _vm._s(_vm.selectedTariffs.length) + " item(s)\n        ")])]) : _vm._e()])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6c1d6de3"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modules/admin/components/Tariff/TariffSearchResults.vue
// module id = 2216
// module chunks = 1